"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateMachine = exports.SubscriptionType = void 0;
const state_node_1 = require("./state-node");
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["TransitionStart"] = "TransitionStart";
    SubscriptionType["TransitionChange"] = "TransitionChange";
    SubscriptionType["TransitionEnd"] = "TransitionEnd";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
class StateMachine {
    constructor(config, options) {
        this.options = options;
        this.subscriptions = [];
        this.subscriptionLimit = 30; // warn when adding too many subscriptions
        this.isTransitioning = false;
        this.pathMap = new Map();
        this.stateNode = new state_node_1.StateNode(this, config);
        if (!options) {
            this.options = {};
        }
    }
    get isStarted() {
        return Boolean(this.currentState);
    }
    subscribe(type, callback) {
        const index = this.subscriptions.findIndex(s => s.type === type && s.callback === callback);
        if (index > -1) {
            throw new Error('Duplicate subscription. Please unsubscribe the callback before subscribing again.');
        }
        this.subscriptions.push({ type, callback });
        if (this.subscriptions.length > this.subscriptionLimit) {
            console.warn(`More than ${this.subscriptionLimit} subscriptions detected. You can increase the subscription limit by setting the 'subscriptionLimit' property in the StateMachine.`);
        }
    }
    unsubscribe(type, callback) {
        const index = this.subscriptions.findIndex(s => s.type === type && s.callback === callback);
        if (index === -1) {
            throw new Error('Unsubscribe failed. Callback not found. Make sure you are passing the callback reference from the subscribe.');
        }
        this.subscriptions.splice(index, 1);
    }
    /**
     * Start the state machine from the beginning
     */
    start(context) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = {
                path: this.stateNode.path,
                context: context || {}
            };
            this.currentState = state;
            return this.transition();
        });
    }
    /**
     * Resume the state machine at a particular state
     */
    resume(state) {
        this.currentState = state;
        return this.transition();
    }
    resumeContext(context) {
        if (!this.currentState) {
            throw new Error('Cannot resume a context when the state machine has not been started.');
        }
        this.currentState.context = context;
        return this.transition();
    }
    getStateNode(path) {
        return this.pathMap.get(path);
    }
    getAllPaths() {
        return Array.from(this.pathMap.keys());
    }
    getStateNodeRelativeTo(stateNode, relativePath) {
        var _a;
        if (relativePath.startsWith('/')) {
            // absolute path
            return this.pathMap.get(relativePath);
        }
        else if (relativePath.startsWith('../')) {
            // navigate up a path
            if (stateNode.parent) {
                return this.getStateNodeRelativeTo(stateNode.parent, relativePath.slice(3));
            }
            else {
                throw new Error(`No parent state node for path '${relativePath}'`);
            }
        }
        else {
            // look for a sibling state node
            relativePath = relativePath.startsWith('./')
                ? relativePath.slice(2)
                : relativePath;
            const parentPath = ((_a = stateNode.parent) === null || _a === void 0 ? void 0 : _a.path) || '';
            return this.pathMap.get(`${parentPath}/${relativePath}`);
        }
    }
    canTransition(eventName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.currentState) {
                return false;
            }
            const state = Object.assign(Object.assign({}, this.currentState), { isSimulation: true }); // make a copy
            const startPath = state.path;
            const destinationState = yield this._transition(state, eventName);
            return destinationState.path !== startPath;
            // let stateNode = this.pathMap.get(state.path);
            // if (!stateNode) {
            //   console.error(
            //     `Starting from beginning. State node not found for path: ${state.path}`
            //   );
            //   stateNode =
            //     (eventName && this.stateNode.findEvent(eventName, true)) ||
            //     this.stateNode;
            //   console.error('starting from state node', stateNode.path);
            // }
            // // traverse children
            // if (!eventName && stateNode.states && stateNode.states.length > 0) {
            //   const childStateNode = stateNode.states[0];
            //   state.path = childStateNode.path;
            //   return this._transition(state);
            // }
            // let isPassGuards = true;
            // if (stateNode.events) {
            //   const events = stateNode.events.filter(event =>
            //     // process the specific transition or if not provided then perform transient events
            //     eventName ? event.name === eventName : event.isTransient
            //   );
            //   for (const event of events) {
            //     if (event.transitions.length === 0) continue;
            //     for (const transition of event.transitions) {
            //       // check if transition conditions (guards) exists
            //       isPassGuards = true;
            //       if (transition.conditions) {
            //         for (const condition of transition.conditions) {
            //           // simulate guard (ignore promises)
            //           const result = this.runGuardSync(state, condition);
            //           if (typeof result === 'boolean' && !result) {
            //             isPassGuards = false;
            //             break;
            //           }
            //         }
            //       }
            //       if (!isPassGuards) continue; // skip this transition and try the next
            //       const destinationStateNode = this.getStateNodeRelativeTo(
            //         stateNode,
            //         transition.target
            //       );
            //       if (destinationStateNode) {
            //         // console.log('can tranisition to ' + destinationStateNode.name);
            //         return true;
            //       } else {
            //         console.error(
            //           `Did not find destination state node for transition: ${transition.target}`
            //         );
            //       }
            //     }
            //   }
            // }
            // return isPassGuards;
        });
    }
    checkCurrentState() {
        if (!this.currentState) {
            throw new Error('No current state. Try starting or resuming the state first.');
        }
    }
    /**
     * Determine which next events are available to be called based on transition conditions
     */
    nextEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkCurrentState();
            const stateNode = this.pathMap.get(this.currentState.path);
            if (!(stateNode === null || stateNode === void 0 ? void 0 : stateNode.events)) {
                return [];
            }
            const nextEvents = [];
            for (const event of stateNode.events) {
                const { name, isTransient } = event;
                const canTransition = yield this.canTransition(event.name);
                event.isTransient;
                nextEvents.push({ name, isTransient, canTransition });
            }
            return nextEvents;
        });
    }
    transition(eventName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkCurrentState();
            this.isTransitioning = !this.currentState.isSimulation;
            this.currentState = yield this._transition(this.currentState, eventName);
            this.isTransitioning = false;
            return this.currentState;
        });
    }
    _transition(state, eventName, transitionCount = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            state = Object.assign({}, state); // make a copy
            // console.log(`transition(); state = ${state}; eventName: ${eventName}`);
            let stateNode = this.pathMap.get(state.path);
            if (!stateNode) {
                console.warn(`Starting from beginning. State node not found for path: ${state.path}`);
                stateNode =
                    (eventName && this.stateNode.findEvent(eventName, true)) ||
                        this.stateNode;
                console.warn('starting from state node', stateNode.path);
            }
            if (transitionCount === 0) {
                this.publish(SubscriptionType.TransitionStart, state, stateNode);
            }
            else {
                this.publish(SubscriptionType.TransitionChange, state, stateNode);
            }
            yield this.runActions(state, stateNode.onEntry);
            if (transitionCount !== 0) {
                // don't invoke when resuming a transition
                yield this.invokeService(state, stateNode.invoke);
            }
            // traverse children
            if (!eventName && stateNode.states && stateNode.states.length > 0) {
                const childStateNode = stateNode.states[0];
                state.path = childStateNode.path;
                return this._transition(state, undefined, transitionCount + 1);
            }
            if (stateNode.events) {
                const events = stateNode.events.filter(event => 
                // process the specific transition or if not provided then perform transient events
                eventName ? event.name === eventName : event.isTransient);
                let isPassGuards = true;
                for (const event of events) {
                    if (event.transitions.length === 0)
                        continue;
                    // find the first transition to pass (TODO: future state handle parallel transitions)
                    for (const transition of event.transitions) {
                        // check if transition conditions (guards) exists
                        isPassGuards = true;
                        if (transition.conditions) {
                            for (const condition of transition.conditions) {
                                isPassGuards = yield this.runGuard(state, condition);
                                if (!isPassGuards) {
                                    break;
                                }
                            }
                        }
                        if (!isPassGuards)
                            continue; // skip this transition and try the next
                        const destinationStateNode = this.getStateNodeRelativeTo(stateNode, transition.target);
                        if (destinationStateNode) {
                            yield this.runActions(state, stateNode.onExit);
                            state.path = destinationStateNode.path;
                            return this._transition(state, undefined, transitionCount + 1);
                        }
                        else {
                            console.error(`Did not find destination state node for transition: ${transition.target}`);
                        }
                        break;
                    }
                }
            }
            this.publish(SubscriptionType.TransitionEnd, state, stateNode);
            return state;
        });
    }
    publish(type, state, stateNode, contextChanges) {
        if (state.isSimulation) {
            return; // only publish notifications for non-simulations
        }
        this.subscriptions.forEach(subscription => {
            if (subscription.type === type) {
                // make a shallow copy of the state object
                subscription.callback(Object.assign({}, state), stateNode, contextChanges);
            }
        });
    }
    // private runGuardSync(state: State, condition: StateTransitionCondition) {
    //   const guardFunction = this.options?.guards?.[condition.type];
    //   if (guardFunction) {
    //     return guardFunction(state, condition.params);
    //   } else {
    //     console.error(`No guard found for: ${condition.type}`);
    //   }
    // }
    runGuard(state, condition) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const guardFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.guards) === null || _b === void 0 ? void 0 : _b[condition.type];
            if (guardFunction) {
                return guardFunction(state, condition.params);
            }
            else {
                console.error(`No guard found for: ${condition.type}`);
                return;
            }
        });
    }
    runActions(state, actions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!actions || state.isSimulation) {
                return;
            }
            for (const action of actions) {
                const actionFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.actions) === null || _b === void 0 ? void 0 : _b[action.type];
                if (actionFunction) {
                    yield actionFunction(state, action.params);
                }
                else {
                    console.error(`No action found for: ${action.type}`);
                }
            }
        });
    }
    invokeService(state, invoke) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!invoke || state.isSimulation) {
                return;
            }
            // TODO: handle onDone and onError logic
            invoke = Array.isArray(invoke) ? invoke : [invoke];
            const serviceFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b[invoke[0].src];
            if (serviceFunction) {
                return serviceFunction(state, invoke);
            }
            else {
                console.error(`No service found for: ${invoke[0].src}`);
                return;
            }
        });
    }
}
exports.StateMachine = StateMachine;
//# sourceMappingURL=state-machine.js.map